const google_id = process.env["VUE_APP_GOOGLE_KEY_" + window.location.host.split(".")[0].toUpperCase()];

const config = {id: google_id}

export default config
